import { Typography } from '@mui/material';
import Grid from 'components/core/Grid';

import { StyledBulletList } from './styles';

export const CheckMarkList = ({ title, items }: { title: string; items: string[] }) => {
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="h3" mb={2}>
        {title}
      </Typography>
      <StyledBulletList>
        {items.map(item => (
          <li key={item}>{item}</li>
        ))}
      </StyledBulletList>
    </Grid>
  );
};
